"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      value: "",
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        }
      },
      startData: "",
      endData: "",
      pickerOptionsStart: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        }
      },
      pickerOptionsEnd: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        }
      }
    };
  },
  watch: {
    // startData(val) {
    // 	if (val) {
    // 		this.$emit("dateObj", {
    // 			start: val,
    // 			end: this.endData
    // 		});
    // 	}
    // },
  },
  methods: {
    handclickdate: function handclickdate(vm) {
      this.$emit("dateObj", vm);
    },
    change: function change(command) {
      if (command != "自定义") {
        this.value = "";
        this.startData = "";
        this.endData = "";
      }
    },
    changeStart: function changeStart(val) {
      if (this.endData && val) {
        // if (date1 < date2) {
        //   console.log("date1 在 date2 之前");
        // } else if (date1 > date2) {
        //   console.log("date1 在 date2 之后");
        // } else {
        //   console.log("date1 和 date2 相同");
        // }
        if (val > this.endData) {
          this.endData = val;
        }
        var vm = val + "to" + this.startData;
        this.$emit("dateObj", vm);
      }
      console.log("start", val);
    },
    changeEnd: function changeEnd(val) {
      console.log("end", val);
      if (this.startData && val) {
        if (val < this.startData) {
          this.startData = val;
        }
        var vm = this.startData + "to" + val;
        this.$emit("dateObj", vm);
      }
    }
  }
};